import { render, staticRenderFns } from "./SBSNSIcon.html?vue&type=template&id=bcd7ef64&scoped=true&"
import script from "./SBSNSIcon.ts?vue&type=script&lang=ts&"
export * from "./SBSNSIcon.ts?vue&type=script&lang=ts&"
import style0 from "./SBSNSIcon.css?vue&type=style&index=0&id=bcd7ef64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd7ef64",
  null
  
)

export default component.exports